class FmeCampaignCarousel extends HTMLElement {
  connectedCallback() {
    if (this.initialized) return;
    this.initialized = true;
    this.track = this.querySelector('[data-carousel-track]');
    this.slides = Array.from(this.track?.children || []);
    this.dots = Array.from(this.querySelectorAll('.fme-carousel__dot'));
    this.activeIndex = 0;
    this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    this.addEventListener('command', (event) => {
      if (event.command === '--next') this.goTo(this.activeIndex + 1);
      if (event.command === '--previous') this.goTo(this.activeIndex - 1);
      if (event.command === '--go') this.goTo(Number(event.source?.dataset.index || 0));
    });
    this.track?.addEventListener('scroll', () => this.syncFromScroll(), { passive: true });
    this.addEventListener('mouseenter', () => this.pause());
    this.addEventListener('mouseleave', () => this.resume());
    this.addEventListener('focusin', () => this.pause());
    this.addEventListener('focusout', (event) => { if (!this.contains(event.relatedTarget)) this.resume(); });
    this.updateControls();
    if (!this.reducedMotion && this.slides.length > 1) this.start();
  }
  disconnectedCallback() { this.pause(); }
  start() { this.pause(); this.timer = window.setInterval(() => this.goTo(this.activeIndex + 1), 5000); }
  pause() { if (this.timer) window.clearInterval(this.timer); this.timer = null; }
  resume() { if (!this.reducedMotion && this.slides.length > 1) this.start(); }
  goTo(index) {
    if (!this.track || !this.slides.length) return;
    const next = (index + this.slides.length) % this.slides.length;
    const slide = this.slides[next];
    this.track.scrollTo({ left: slide.offsetLeft - this.track.offsetLeft, behavior: this.reducedMotion ? 'auto' : 'smooth' });
    this.activeIndex = next;
    this.updateControls();
  }
  syncFromScroll() {
    if (!this.track || !this.slides.length) return;
    window.clearTimeout(this.scrollTimer);
    this.scrollTimer = window.setTimeout(() => {
      const center = this.track.scrollLeft + this.track.clientWidth / 2;
      let closest = 0;
      let distance = Number.POSITIVE_INFINITY;
      this.slides.forEach((slide, index) => {
        const currentDistance = Math.abs(center - (slide.offsetLeft + slide.clientWidth / 2));
        if (currentDistance < distance) { closest = index; distance = currentDistance; }
      });
      this.activeIndex = closest;
      this.updateControls();
    }, 80);
  }
  updateControls() {
    this.dots.forEach((dot, index) => {
      if (index === this.activeIndex) dot.setAttribute('aria-current', 'true');
      else dot.removeAttribute('aria-current');
    });
  }
}
if (!customElements.get('fme-campaign-carousel')) customElements.define('fme-campaign-carousel', FmeCampaignCarousel);
